import { pickBy } from "lodash";
import { tPdBadgeColorScheme } from "src/components/v2/layout";
import { formatMoney } from "src/util/gFormatting";
import { includesIn } from "src/util/search";
import { tProductStatus, tTableProduct, tUpdated } from "./types";

const formatInputMoney = (value: string | number) => formatMoney(value).split("$")[1];

export const getUpdatedRow = (row: tTableProduct, updated: tUpdated): tUpdated =>
  row.isVariant ? pickBy(updated, (u) => u.variantSku === row.sku) : updated;

export const getInventory = (row: tTableProduct, updated: tUpdated): number => {
  const rowValue = getUpdatedRow(row, updated);
  return rowValue[row.id]?.inventory !== undefined ? rowValue[row.id].inventory || 0 : row.inventory;
};

export const getWholesalePrice = (row: tTableProduct, updated: tUpdated): string => {
  const rowValue = getUpdatedRow(row, updated);
  return rowValue[row.id]?.wholesalePrice || formatInputMoney(row.wholesalePrice);
};

export const getMsrpPrice = (row: tTableProduct, updated: tUpdated): string => {
  const rowValue = getUpdatedRow(row, updated);
  return rowValue[row.id]?.msrpPrice || formatInputMoney(row.msrpPrice);
};

export const getTesterPrice = (row: tTableProduct, updated: tUpdated): string => {
  const rowValue = getUpdatedRow(row, updated);
  return rowValue[row.id]?.testerPrice || formatInputMoney(row.testerPrice);
};

export const getColorSchemeFromStatus = (status: tProductStatus): tPdBadgeColorScheme => {
  if (status === tProductStatus.OutOfStock) return "red";
  if (status === tProductStatus.Unpublished) return "orange";
  return "green";
};

export const subRowIncludesStatus = (data: tTableProduct[], status: tProductStatus): boolean => {
  let result = false;
  for (const row of data) {
    if (row.status === status) {
      result = true;
      break;
    }
  }
  return result;
};

export const subRowIncludesTerm = (data: tTableProduct[], term: string): boolean => {
  let result = false;
  for (const row of data) {
    if (includesIn(row, term)) {
      result = true;
    }
  }
  return result;
};
